export default "__VITE_ASSET__10e73786__"